// Preguntas sugeridas de Ari por ruta. Editable aquí, no hardcodeado en el componente.
// Se elige por prefijo de ruta (la más específica gana). Si ninguna casa → GENERICOS.

export const GENERICOS = [
  "¿Cómo subo un documento?",
  "¿Cómo registro un control de calidad?",
  "¿Cómo hago un simulacro de retirada?",
  "¿Qué son los gaps?",
];

const POR_RUTA = [
  {
    prefijo: "/documentos",
    chips: [
      "¿Cómo subo documentos con IA?",
      "¿Cómo creo una nueva versión?",
      "¿Qué significa que un documento está incompleto?",
    ],
  },
  {
    prefijo: "/calidad",
    chips: [
      "¿Cómo registro un control?",
      "¿Qué pasa si un valor sale de límites?",
      "¿Cómo hago una revisión libre?",
    ],
  },
  {
    prefijo: "/lotes",
    chips: [
      "¿Cómo bloqueo un lote?",
      "¿Cómo hago un simulacro de retirada?",
      "¿Cómo imprimo etiquetas?",
    ],
  },
  {
    prefijo: "/traza",
    chips: [
      "¿Cómo bloqueo un lote?",
      "¿Cómo hago un simulacro de retirada?",
      "¿Cómo imprimo etiquetas?",
    ],
  },
  {
    prefijo: "/gaps",
    chips: [
      "¿Qué es un gap KO?",
      "¿Cómo cierro un gap?",
      "¿Qué es el plan de acción sugerido?",
    ],
  },
];

export function chipsParaRuta(pathname) {
  const ruta = pathname || "";
  const match = POR_RUTA.filter((r) => ruta.startsWith(r.prefijo)).sort(
    (a, b) => b.prefijo.length - a.prefijo.length
  )[0];
  return match ? match.chips : GENERICOS;
}
